import styled, {css} from "styled-components";

export const SwedenResponsibleGamingButtonSBGIconClassName = "sweden-responsible-gaming-button-svg-icon";

export const SwedenResponsibleGamingButtonBaseBox = styled.button<{useIconsOnly: boolean}>`
  background-repeat: no-repeat;
  background-size: contain;
  cursor: pointer;
  &:hover {
    opacity: 0.5;
  }
  
  .${SwedenResponsibleGamingButtonSBGIconClassName} {
    width: 100%;
    height: auto;
  }
  
  ${props => props.useIconsOnly
          ? css`
            width: 25px;
            height: 24px;
          `
          : css`
            width: 100px;
            height: 30px;
          `
  }
`